import { useSelector } from "react-redux";
//import { determineFaceTimeSupport } from "@wolzienllc/vcc-react-commons";
import AssignedAlert from "./AssignedAlert";
import CallingAlert from "./CallingAlert";
//import FacetimeForm from "./FacetimeForm";
import Tips from "./Tips";

const ContentAreaText = () => {
  const { initialized, /*participantData,*/ queueState } = useSelector(
    (state) => state
  );

  //const state = useSelector((state) => state);

  //const { error, initialized, /*participantData,*/ queueState } = state;

  //const shouldRequestFaceTime = false;
  //const participantOnFaceTimeDevice = determineFaceTimeSupport();

  const shouldDisplayTips = [
    "qAssigned",
    "qCalled",
    "qNot",
    "qReady",
    "qUnassigned",
  ].includes(queueState);

  //const shouldDisplayFacetimePrompt = false; //queueState === "qNot" || queueState === "qReady";

  return (
    <>
      {/*<div
        style={{
          width: "90vw",
          maxWidth: "90vw",
          maxHeight: "40vh",
          wordWrap: "break-word",
          overflowY: "scroll",
        }}
      >
        State:
        <br />
        {JSON.stringify(state)}
      </div>
      <br />
      <>*/}
      {Boolean(initialized) && (
        <div
          className="fullWidth"
          style={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: "1%",
          }}
        >
          {(queueState === "qCalled" || queueState === "qAssigned") && (
            <AssignedAlert />
          )}
          {queueState === "qCalling" && <CallingAlert />}
          {/*shouldDisplayFacetimePrompt &&
              shouldRequestFaceTime &&
              participantOnFaceTimeDevice &&
              participantData && (
                <FacetimeForm participantData={participantData} />
              )*/}
          {shouldDisplayTips && <Tips />}
        </div>
      )}
      {/*</>*/}
    </>
  );
};

export default ContentAreaText;
